import React, { useMemo } from 'react'

import { professorFields } from './profFields'
import { useProfileForm, useUser } from '../../../context'
import SectionFields from '../DynamicFields/SectionFields'

const ProfessorSection = () => {
  const { onEditionMode, userRole } = useUser()
  const { values, formActions, isNewUser } = useProfileForm()

  const isDisabled = isNewUser ? isNewUser : onEditionMode

  const fields = useMemo(
    () => professorFields({ state: values, userRole }),
    [values, userRole],
  )
  return (
    <SectionFields
      fields={fields}
      formActions={formActions}
      isDisabled={isDisabled}
    />
  )
}

export default ProfessorSection
